export default __webpack_public_path__ + "static/media/480_dummy2016-tennisclub01-mobile-de.db14c6a9.png";